import React, { FC } from 'react'

const SBPLogo: FC = () => (
  <svg width="59" height="32" viewBox="0 0 59 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M59 11.9151V20.124H56.1243V14.3569H53.355V20.124H50.4793V11.9151H59Z" fill="white" />
    <path
      d="M46.1914 16.4683C46.1941 15.5198 45.4654 14.7247 44.4766 14.7247C43.499 14.7247 42.7322 15.5285 42.7504 16.4848C42.7504 17.4918 43.6438 18.1781 44.4231 18.1781C45.4119 18.1781 46.1914 17.4303 46.1914 16.4683ZM49.0628 16.2804C49.1056 18.6647 47.1839 20.3613 44.4618 20.3613C41.8843 20.3613 39.713 18.7975 39.713 14.9889C39.713 11.7538 41.7727 9.088 44.821 9.03697C46.1561 9.03697 49.0608 9.02717 49.0608 9.02717L47.7152 11.4611H45.1221C43.8066 11.4611 42.6342 12.3492 42.4664 13.7072C43.1665 13.051 44.2546 12.655 45.3809 12.655C47.4824 12.661 49.0331 14.4513 49.0628 16.2804Z"
      fill="white"
    />
    <path
      d="M37.4959 17.3171C37.4959 17.3171 36.5314 17.9672 35.2431 17.9439C34.4359 17.9439 33.3545 17.2411 33.3545 15.9932C33.37 14.7264 34.442 14.0468 35.2479 14.0468C36.5038 14.0066 37.4959 14.6743 37.4959 14.6743L38.5676 12.7357C37.6156 12.044 36.7049 11.6848 35.4045 11.6754C32.5958 11.6754 30.6661 13.9634 30.6661 15.9955C30.6661 18.3798 32.8131 20.3475 35.3887 20.3607C36.5227 20.3796 37.6826 19.9967 38.577 19.2878L37.4959 17.3171Z"
      fill="white"
    />
    <path d="M8.02379 16.0006L3.86282 18.4103L0 25.1208L15.7494 16.0006H8.02379Z" fill="#874691" />
    <path d="M19.9075 9.1194L15.7466 11.529L11.8837 18.2396L27.6332 9.1194H19.9075Z" fill="#DA1844" />
    <path d="M15.7466 6.71088L11.8837 0V32L15.7466 25.2888V6.71088Z" fill="#F9B229" />
    <path d="M11.8837 0L15.7466 6.71088L19.9075 9.12099H27.6332L11.8837 0Z" fill="#F07F1A" />
    <path d="M11.8837 13.7593V32L15.7466 25.2888V20.4699L11.8837 13.7593Z" fill="#72B22C" />
    <path d="M19.9075 22.8795L15.7466 25.2888L11.8837 32L27.6332 22.8795H19.9075Z" fill="#00743E" />
    <path d="M0 6.88014V25.1208L3.86282 18.4103V13.591L0 6.88014Z" fill="#5F5A94" />
    <path
      d="M11.8866 13.7592L11.89 13.7653L0 6.88014L3.86282 13.591L19.9104 22.8794H27.636L11.8866 13.7592Z"
      fill="#0D90CD"
    />
  </svg>
)

export default SBPLogo
